import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./PacienteSubviewLayout.css";

export default function PacienteSubviewLayout({ paciente, totals, title, children }) {
  const navigate = useNavigate();
  const location = useLocation();

  const totalCosto = totals?.totalCosto ?? 0;
  const totalAbonado = totals?.totalAbonado ?? 0;
  const balance = totalAbonado - totalCosto;
  const estaAlDia = balance >= -0.1;

  const volverAPacientes = () => {
    if (location.state?.fromPacientes) {
      navigate(-1);
      return;
    }
    navigate("/pacientes");
  };

  return (
    <div className="psl-shell">
      <div className="psl-topbar-wrap">
        <div className="pp-card psl-topbar">
          <div className="psl-topbar-main">
            <button type="button" className="boton-secundario psl-back-btn" onClick={volverAPacientes}>
              ← Volver a Pacientes
            </button>
            <div className="psl-title-wrap">
              <h1 className="psl-title">{title}</h1>
              <p className="psl-subtitle">
                {paciente ? `${paciente.nombre || ""} ${paciente.apellido || ""}`.trim() : "Cargando paciente..."}
              </p>
            </div>
            <span className={`pp-btn-estado ${estaAlDia ? "al-dia" : "debe"} psl-badge`}>
              <span>{estaAlDia ? "✓" : "!"}</span>
              {estaAlDia ? "Al día" : "Debe"}
            </span>
          </div>
        </div>
      </div>
      <div className="pp-card psl-content">{children}</div>
    </div>
  );
}
